import Vue from 'vue'
import VueRouter from 'vue-router'

import { Message } from 'element-ui';
import { updateMetaTags } from '@/utils/meta';

Vue.use(VueRouter)
Vue.prototype.$message = Message;

const routes = [
  {
    path: '/',
    name: 'front',
    redirect: "/topview",
    component: () => import('../views/front/Front.vue'),
    meta: {
      title: '环小微',
      breadcrumb: '环小微',
      requireAuth: false,
      description: '安徽环小微环境科技有限公司 - 专业的环境服务提供商，提供危废收集转运、危废管理全托管、环境影响评价等一站式环保解决方案',
      keywords: '环小微,环境科技,危废处理,环保服务,环境影响评价,安徽环小微,危险废物,环保解决方案，环境，环境咨询,环保,环境服务，安徽环保，安徽环境咨询服务',
      logo: '/img/logo.ico',
      ogImage: '/img/logo.ico',
      icon: '/img/logo.ico'
    },
    children: [
      {
        path: 'topview',
        name: 'topview',
        meta: {
          breadcrumb: '环小微',
          title: '安徽环小微环境科技有限公司',
          description: '安徽环小微环境科技有限公司 - 专业的环境服务提供商，提供危废收集转运、危废管理全托管、环境影响评价等一站式环保解决方案',
          keywords: '环小微,环境科技,危废处理,环保服务,环境影响评价,安徽环小微,危险废物,环保解决方案，环境，环境咨询',
          logo: '/img/logo.ico',
          ogImage: '/img/logo.ico',
          icon: '/img/logo.ico'
        },
        component: () => import('../views/front/TopView.vue')
      },
      {
        path: 'about',
        name: 'about',
        meta: { breadcrumb: '关于我们', title: '关于我们' },
        component: () => import('@/views/about.vue'),
        redirect: '/about/company', // 添加重定向规则，默认显示公司简介
        children: [
          {
            path: 'company',
            name: 'Company',
            meta: { breadcrumb: '公司简介', title: '公司简介' },
            component: () => import('@/views/front/about/Company.vue')
          },
          {
            path: 'culture',
            name: 'culture',
            meta: { breadcrumb: '企业文化', title: '企业文化' },
            component: () => import('@/views/front/about/Culture.vue')
          },
          {
            path: 'leadership',
            name: 'leadership',
            meta: { breadcrumb: '领导致辞', title: '领导致辞' },
            component: () => import('../views/front/about/Leadership.vue')
          },
          // { 
          //   path: 'business', 
          //   name: 'business', 
          //   meta: { breadcrumb: '企业资质', title: '企业资质' }, 
          //   component: () => import('../views/front/about/Business.vue') 
          // },
          // { 
          //   path: 'development-history', 
          //   name: 'developmentHistory', 
          //   meta: { breadcrumb: '发展历程', title: '发展历程' }, 
          //   component: () => import('../views/front/about/DevelopmentHistory.vue') 
          // },
          // { 
          //   path: 'Scene', 
          //   name: 'Scene', 
          //   meta: { breadcrumb: '公司实景', title: '公司实景' }, 
          //   component: () => import('../views/front/about/Scene.vue') 
          // }
        ]
      },
      // 主营业务版块
      {
        path: 'business',
        name: 'Business',
        meta: { breadcrumb: '主营业务', title: '主营业务' },
        component: () => import('../views/front/business/Business.vue'),
        children: [
          {
            path: 'fly-ash',
            name: 'FlyAsh',
            meta: { breadcrumb: '危废收集转运', title: '危废收集转运' },
            component: () => import('../views/front/business/FlyAsh.vue')
          },
          {
            path: 'activated-carbon',
            name: 'ActivatedCarbon',
            meta: { breadcrumb: '危废管理全托管', title: '危废管理全托管' },
            component: () => import('../views/front/business/ActivatedCarbon.vue')
          },
          {
            path: 'sludge',
            name: 'Sludge',
            meta: { breadcrumb: '危险废物贮存库', title: '危险废物贮存库' },
            component: () => import('../views/front/business/Sludge.vue')
          },
          {
            path: 'environmental-impact',
            name: 'EnvironmentalImpact',
            meta: { breadcrumb: '环境影响评价', title: '环境影响评价' },
            component: () => import('../views/front/business/EnvironmentalImpact.vue')
          },
          {
            path: 'emergency-plan',
            name: 'EmergencyPlan',
            meta: { breadcrumb: '环境应急预案编制', title: '环境应急预案编制' },
            component: () => import('../views/front/business/EmergencyPlan.vue')
          },
          {
            path: 'emergency-drill',
            name: 'EmergencyDrill',
            meta: { breadcrumb: '环境应急演练', title: '环境应急演练' },
            component: () => import('../views/front/business/EmergencyDrill.vue')
          },
          {
            path: 'permit-management',
            name: 'PermitManagement',
            meta: { breadcrumb: '排污许可证管理', title: '排污许可证管理' },
            component: () => import('../views/front/business/PermitManagement.vue')
          },
          {
            path: 'pollution-monitoring',
            name: 'PollutionMonitoring',
            meta: { breadcrumb: '排污自行监测', title: '排污自行监测' },
            component: () => import('../views/front/business/PollutionMonitoring.vue')
          },
          {
            path: 'project-acceptance',
            name: 'ProjectAcceptance',
            meta: { breadcrumb: '环保项目验收', title: '环保项目验收' },
            component: () => import('../views/front/business/ProjectAcceptance.vue')
          }
        ]
      },
      // 新闻资讯版块
      {
        path: 'news',
        name: 'News',
        meta: { breadcrumb: '新闻资讯', title: '新闻资讯' },
        component: () => import('../views/front/news/News.vue'),
        redirect: '/news/category/1',
        children: [
          {
            path: 'list',
            name: 'NewsList',
            meta: { breadcrumb: '新闻列表', title: '新闻列表' },
            component: () => import('../views/front/news/NewsList.vue')
          },
          {
            path: 'detail/:id',
            name: 'NewsDetail',
            meta: { breadcrumb: '新闻详情', title: '新闻详情' },
            component: () => import('../views/front/news/NewsDetail.vue')
          },
          {
            path: 'category/:cid',
            name: 'NewsCategory',
            meta: { breadcrumb: '分类新闻', title: '分类新闻' },
            component: () => import('../views/front/news/NewsList.vue')
          }
        ]
      },
      // 商务合作版块
      {
        path: 'cooperation',
        name: 'Cooperation',
        meta: { breadcrumb: '商务合作', title: '商务合作' },
        component: () => import('../views/front/cooperation/Cooperation.vue'),
        redirect: '/cooperation/strategic',
        children: [
          {
            path: 'strategic',
            name: 'StrategicCooperation',
            meta: { breadcrumb: '联营合作', title: '联营合作' },
            component: () => import('../views/front/cooperation/StrategicCooperation.vue')
          },
          // {
          //   path: 'technical',
          //   name: 'TechnicalCooperation',
          //   meta: { breadcrumb: '技术合作', title: '技术合作' },
          //   component: () => import('../views/front/cooperation/TechnicalCooperation.vue')
          // },
          {
            path: 'investment',
            name: 'InvestmentCooperation',
            meta: { breadcrumb: '投资合作', title: '投资合作' },
            component: () => import('../views/front/cooperation/InvestmentCooperation.vue')
          }
        ]
      },
      // 联系我们版块
      {
        path: 'contact',
        name: 'Contact',
        meta: { breadcrumb: '联系我们', title: '联系我们' },
        component: () => import('../views/front/contact/Contact.vue'),
        redirect: '/contact/info',
        children: [
          {
            path: 'info',
            name: 'ContactInfo',
            meta: { breadcrumb: '联系方式', title: '联系方式' },
            component: () => import('../views/front/contact/ContactInfo.vue')
          },
        ]
      },
      // 注册流程指南
      {
        path: 'register-guide',
        name: 'RegisterGuide',
        meta: { breadcrumb: '注册流程指南', title: '注册流程指南' },
        component: () => import('../views/front/register/RegisterGuide.vue')
      },
    ]
  },

  {
    path: '*',
    name: 'notFound',
    meta: { title: '找不到页面' },
    component: () => import('../views/404NotFound.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 解决Vue Router在3.0版本以上重复点击导航时的控制台报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 忽略导航取消和重复导航错误
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    // 忽略导航取消和重复导航错误
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      throw err
    }
  })
}

router.beforeEach((to, from, next) => {
  // 合并父路由和子路由的meta信息
  const matched = to.matched;
  let mergedMeta = {};

  // 从父路由到子路由合并meta信息
  matched.forEach(record => {
    mergedMeta = { ...mergedMeta, ...record.meta };
  });

  // 使用自定义函数更新meta标签
  updateMetaTags(mergedMeta);

  // 检查是否是同一路由跳转（但允许不同ID的新闻详情页跳转）
  if (to.path === from.path && to.params.id === from.params.id) {
    // 如果是完全相同的路由（包括参数），则不进行跳转，也不刷新页面
    // 直接取消导航，避免页面闪烁和错误提示
    next(false);
  } else {
    from.meta.hasPopup ? setTimeout(() => next(), 100) : next();
  }
});



export default router